// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: qtWvXH8Uhh67sc1TY2MZeK
// Component: RkBFuHrIeu0V

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import projectcss from "./plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import sty from "./PlasmicLogo.module.css"; // plasmic-import: RkBFuHrIeu0V/css

createPlasmicElementProxy;

export type PlasmicLogo__VariantMembers = {
  app: "hubHub" | "mapMap";
  size: "small" | "medium" | "large";
};
export type PlasmicLogo__VariantsArgs = {
  app?: SingleChoiceArg<"hubHub" | "mapMap">;
  size?: SingleChoiceArg<"small" | "medium" | "large">;
};
type VariantPropType = keyof PlasmicLogo__VariantsArgs;
export const PlasmicLogo__VariantProps = new Array<VariantPropType>(
  "app",
  "size"
);

export type PlasmicLogo__ArgsType = {};
type ArgPropType = keyof PlasmicLogo__ArgsType;
export const PlasmicLogo__ArgProps = new Array<ArgPropType>();

export type PlasmicLogo__OverridesType = {
  root?: p.Flex<"div">;
  freeBox?: p.Flex<"div">;
  markContainer?: p.Flex<"div">;
  appName?: p.Flex<"div">;
  textContainerA?: p.Flex<"div">;
  textContainerB?: p.Flex<"div">;
};

export interface DefaultLogoProps {
  app?: SingleChoiceArg<"hubHub" | "mapMap">;
  size?: SingleChoiceArg<"small" | "medium" | "large">;
  className?: string;
}

const $$ = {};

function PlasmicLogo__RenderFunc(props: {
  variants: PlasmicLogo__VariantsArgs;
  args: PlasmicLogo__ArgsType;
  overrides: PlasmicLogo__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "app",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.app
      },
      {
        path: "size",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.size
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        sty.root,
        { [sty.rootapp_mapMap]: hasVariant($state, "app", "mapMap") }
      )}
    >
      <p.Stack
        as={"div"}
        data-plasmic-name={"freeBox"}
        data-plasmic-override={overrides.freeBox}
        hasGap={true}
        className={classNames(projectcss.all, sty.freeBox, {
          [sty.freeBoxapp_mapMap]: hasVariant($state, "app", "mapMap"),
          [sty.freeBoxsize_large]: hasVariant($state, "size", "large"),
          [sty.freeBoxsize_medium]: hasVariant($state, "size", "medium")
        })}
      >
        <div
          data-plasmic-name={"markContainer"}
          data-plasmic-override={overrides.markContainer}
          className={classNames(projectcss.all, sty.markContainer, {
            [sty.markContainerapp_mapMap]: hasVariant($state, "app", "mapMap"),
            [sty.markContainersize_large]: hasVariant($state, "size", "large"),
            [sty.markContainersize_medium]: hasVariant($state, "size", "medium")
          })}
        >
          <p.PlasmicImg
            alt={""}
            className={classNames(sty.img___5D5Ff, {
              [sty.imgapp_mapMap___5D5Ff5NMoN]: hasVariant(
                $state,
                "app",
                "mapMap"
              ),
              [sty.imgsize_large___5D5FfehXio]: hasVariant(
                $state,
                "size",
                "large"
              )
            })}
            displayHeight={"auto"}
            displayMaxHeight={"none"}
            displayMaxWidth={"100%"}
            displayMinHeight={"0"}
            displayMinWidth={"0"}
            displayWidth={"auto"}
            loader={"plasmic"}
            loading={"lazy"}
            src={
              hasVariant($state, "app", "mapMap")
                ? {
                    src: "https://site-assets.plasmic.app/6d3232254450ea94b1a74b1866452b6b.svg",
                    fullWidth: 163,
                    fullHeight: 150,
                    aspectRatio: 1.085366
                  }
                : {
                    src: "https://site-assets.plasmic.app/03f107b1719117a0daf940cfa8113c4d.svg",
                    fullWidth: 101,
                    fullHeight: 150,
                    aspectRatio: 0.675676
                  }
            }
          />
        </div>
        <p.Stack
          as={"div"}
          data-plasmic-name={"appName"}
          data-plasmic-override={overrides.appName}
          hasGap={true}
          className={classNames(projectcss.all, sty.appName)}
        >
          <div
            data-plasmic-name={"textContainerA"}
            data-plasmic-override={overrides.textContainerA}
            className={classNames(projectcss.all, sty.textContainerA, {
              [sty.textContainerAsize_large]: hasVariant(
                $state,
                "size",
                "large"
              ),
              [sty.textContainerAsize_medium]: hasVariant(
                $state,
                "size",
                "medium"
              )
            })}
          >
            <p.PlasmicImg
              alt={""}
              className={classNames(sty.img__tdstd, {
                [sty.imgapp_mapMap__tdstd5NMoN]: hasVariant(
                  $state,
                  "app",
                  "mapMap"
                ),
                [sty.imgsize_large__tdstDehXio]: hasVariant(
                  $state,
                  "size",
                  "large"
                ),
                [sty.imgsize_medium__tdstdFp4Gp]: hasVariant(
                  $state,
                  "size",
                  "medium"
                )
              })}
              displayHeight={"auto"}
              displayMaxHeight={"none"}
              displayMaxWidth={"100%"}
              displayMinHeight={"0"}
              displayMinWidth={"0"}
              displayWidth={"auto"}
              loader={"plasmic"}
              loading={"lazy"}
              src={
                hasVariant($state, "app", "mapMap")
                  ? {
                      src: "https://site-assets.plasmic.app/e4b4ad631dbea9092e7c249405afd403.svg",
                      fullWidth: 271,
                      fullHeight: 150,
                      aspectRatio: 1.807692
                    }
                  : {
                      src: "https://site-assets.plasmic.app/e6fc5a6e8f7f3aeb8b7333d0e10a3402.svg",
                      fullWidth: 300,
                      fullHeight: 143,
                      aspectRatio: 2.090909
                    }
              }
            />
          </div>
          <div
            data-plasmic-name={"textContainerB"}
            data-plasmic-override={overrides.textContainerB}
            className={classNames(projectcss.all, sty.textContainerB, {
              [sty.textContainerBsize_large]: hasVariant(
                $state,
                "size",
                "large"
              ),
              [sty.textContainerBsize_medium]: hasVariant(
                $state,
                "size",
                "medium"
              )
            })}
          >
            <p.PlasmicImg
              alt={""}
              className={classNames(sty.img__eKyrl, {
                [sty.imgapp_mapMap__eKyrl5NMoN]: hasVariant(
                  $state,
                  "app",
                  "mapMap"
                ),
                [sty.imgsize_large__eKyrlehXio]: hasVariant(
                  $state,
                  "size",
                  "large"
                ),
                [sty.imgsize_medium__eKyrlFp4Gp]: hasVariant(
                  $state,
                  "size",
                  "medium"
                )
              })}
              displayHeight={"auto"}
              displayMaxHeight={"none"}
              displayMaxWidth={"100%"}
              displayMinHeight={"0"}
              displayMinWidth={"0"}
              displayWidth={"auto"}
              loader={"plasmic"}
              loading={"lazy"}
              src={
                hasVariant($state, "app", "mapMap")
                  ? {
                      src: "https://site-assets.plasmic.app/88e288688a168c9d77fd263e09e1edbe.svg",
                      fullWidth: 281,
                      fullHeight: 150,
                      aspectRatio: 1.875
                    }
                  : {
                      src: "https://site-assets.plasmic.app/5b02c1539529dbe17d9d9972f7e4bb40.svg",
                      fullWidth: 300,
                      fullHeight: 136,
                      aspectRatio: 2.2
                    }
              }
            />
          </div>
        </p.Stack>
      </p.Stack>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "freeBox",
    "markContainer",
    "appName",
    "textContainerA",
    "textContainerB"
  ],
  freeBox: [
    "freeBox",
    "markContainer",
    "appName",
    "textContainerA",
    "textContainerB"
  ],
  markContainer: ["markContainer"],
  appName: ["appName", "textContainerA", "textContainerB"],
  textContainerA: ["textContainerA"],
  textContainerB: ["textContainerB"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  freeBox: "div";
  markContainer: "div";
  appName: "div";
  textContainerA: "div";
  textContainerB: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicLogo__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicLogo__VariantsArgs;
    args?: PlasmicLogo__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicLogo__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicLogo__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicLogo__ArgProps,
          internalVariantPropNames: PlasmicLogo__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicLogo__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicLogo";
  } else {
    func.displayName = `PlasmicLogo.${nodeName}`;
  }
  return func;
}

export const PlasmicLogo = Object.assign(
  // Top-level PlasmicLogo renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    freeBox: makeNodeComponent("freeBox"),
    markContainer: makeNodeComponent("markContainer"),
    appName: makeNodeComponent("appName"),
    textContainerA: makeNodeComponent("textContainerA"),
    textContainerB: makeNodeComponent("textContainerB"),

    // Metadata about props expected for PlasmicLogo
    internalVariantProps: PlasmicLogo__VariantProps,
    internalArgProps: PlasmicLogo__ArgProps
  }
);

export default PlasmicLogo;
/* prettier-ignore-end */
